import {
  getRelativeFontSize,
  primaryBlueColor,
  primaryLightGray,
  regularFont,
} from "../../../utils/styles";

const CustomBreadcrumbStyles = {
  breadcrumbWrapper: {
    background: "#F5F7F9",
    height: "44px",
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    padding: "0 20px",
  },

  textStyle: {
    cursor: "pointer",
    color: primaryLightGray,
    fontSize: getRelativeFontSize(-2),
    ...regularFont,
    "& a": {
      color: primaryBlueColor,
      textDecoration: "none",
    },
  },
  activeLink: {
    color: "red",
  },
};

export default CustomBreadcrumbStyles;
